import React from 'react';
const ArrowTopDouble = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M21.504 555.776L519.232 57.984l498.496 498.496-45.248 45.248L519.232 148.48l-452.48 452.672z" />
    <path d="M21.504 919.232l497.728-497.728 498.496 498.496-45.248 45.248L519.232 512l-452.48 452.48z" />
  </svg>
);
export default ArrowTopDouble;
